import { useQuery } from '@apollo/client';
import { SCENARIO_GROUPS, SCENARIO_GROUPS_WITH_SCENARIOS } from './schemas/queries/data';

type ScenarioGroupsVariables = {
  workspaceId?: string;
};

export type ScenarioGroupScenario = {
  id: string;
  name?: string | null;
  description?: string | null;
  status?: string | null;
  source?: number | null;
  event?: number | null;
  consequence?: number | null;
  riskNarrative?: string | null;
  frequencyNote?: string | null;
  managementStrategy?: string | null;
  managementNote?: string | null;
  consequenceNote?: string | null;
  lowerFormula?: string | null;
  upperFormula?: string | null;
  ownerName?: string | null;
  riskIdentifiedDate?: string | null;
  reviewDate?: string | null;
  baseRisk?: {
    frequencyTimes?: number | null;
    frequencyYears?: number | null;
    expectedLoss?: number | null;
    lower?: number | null;
    upper?: number | null;
  } | null;
  projectedRisk?: {
    frequencyTimes?: number | null;
    frequencyYears?: number | null;
    expectedLoss?: number | null;
    lower?: number | null;
    upper?: number | null;
  } | null;
  liveRisk?: {
    frequencyTimes?: number | null;
    frequencyYears?: number | null;
    expectedLoss?: number | null;
    lower?: number | null;
    upper?: number | null;
  } | null;
  meta?: {
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
  assessment?: { id: string } | null;
};

export type ScenarioGroupSummary = {
  id: string;
  name: string;
  description?: string | null;
  author?: string | null;
  authorLogoPath?: string | null;
  category?: string | null;
  featureKey?: string | null;
  isSystem?: boolean | null;
  scenarios: {
    id: string;
    meta?: {
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
  }[];
};

export type ScenarioGroupWithDetails = Omit<ScenarioGroupSummary, 'scenarios'> & {
  scenarios: ScenarioGroupScenario[];
};

export const useScenarioGroups = (workspaceId?: string) =>
  useQuery<{ scenarioGroups: ScenarioGroupSummary[] }, ScenarioGroupsVariables>(SCENARIO_GROUPS, {
    variables: { workspaceId },
  });

export const useScenarioGroupsWithScenarios = (workspaceId?: string) =>
  useQuery<{ scenarioGroups: ScenarioGroupWithDetails[] }, ScenarioGroupsVariables>(
    SCENARIO_GROUPS_WITH_SCENARIOS,
    { variables: { workspaceId } },
  );
